import AddOpportunity from "./AddOpportunity";
import AddPricebook from "./Pricebook/AddPricebook";
import AgGridWrapper from "./AgGridWrapper";
import AppUpdateNotification from "./AppUpdateNotification";
import AssetDetailsPopupWrapper from "./AssetDetailsPopupWrapper";
import AttachmentComponent from "./AttachmentComponent";
import AssetWrapper from "./AssetWrapper";
import ControlBar from "./ControlBar";
import CreateDocumentPopup from "./CreateDocumentPopup";
import CreateQuotePopup from "./CreateQuotePopup";
import CreateTemplatePopup from "./CreateTemplatePopup";
import CustomRevvEditor from "./CustomRevvEditor";
import CustomRevvToolbar from "./CustomRevvToolbar";
import DashboardWrapper from "./DashboardWrapper";
import DealTable from "./DealTable";
import DealTableFooter from "./DealTable/DealTableFooter";
import Document from "./Document";
import DocumentComponents from "./DocumentComponents";
import DocumentDetails from "./DocumentDetails";
import DocumentItems from "./DocumentItems";
import DocumentTemplate from "./Template";
import DocumentToolBar from "./DocumentToolBar";
import DocumentWrapper from "./DocumentWrapper";
import EditEditor from "./RevvEditor";
import ErrorFourOhFour from "./ErrorComponents";
import IFrameSignature from "./IFrameSignature";
import ListDocTemplates from "./DocTemplates";
import NavBarWrapper from "./NavBarWrapper";
import Notes from "./Notes";
import NotifyBanner from "./NotifyBanner";
import PipelineWrapper from "./PipelineWrapper";
import PricebookGrid from "./Pricebook/PricebookGrid";
import ProductGrid from "./Products";
import QuotationTopBarV2 from "./QuotationTopBarV2";
import QuotationTopbar from "./QuotationTopbar";
import QuotationUpload from "./QuotationUpload";
import Table from "./RevvTable";
import TitleBar from "./TitleBar";
import ToolPaneWrapper from "./ToolPaneWrapper";
import { AssetsDetails, AssetsLeftFilter } from "./AssetsWrapper";
import { KanbanHeader, KanbanWrapper } from "./Kanban";
import { PricebookList, PriceListCard } from "./Pricebook/PricebookList";
import { WorkFlowList, ApprovalWrapper } from "./WorkFlow";
import { AuthenticateUser } from "./AuthComponents";
import {
  TemplateLeftSection,
  OrgTemplates,
  GlobalTemplates,
} from "./TemplateV2";
import BillingBandInfo from "./BillingBandInfo";

export {
  AddOpportunity,
  AddPricebook,
  AgGridWrapper,
  AppUpdateNotification,
  ApprovalWrapper,
  AssetDetailsPopupWrapper,
  AssetWrapper,
  AssetsDetails,
  AssetsLeftFilter,
  AttachmentComponent,
  AuthenticateUser,
  ControlBar,
  CreateDocumentPopup,
  CreateQuotePopup,
  CreateTemplatePopup,
  CustomRevvEditor,
  CustomRevvToolbar,
  DashboardWrapper,
  DealTable,
  DealTableFooter,
  Document,
  DocumentComponents,
  DocumentDetails,
  DocumentItems,
  DocumentTemplate,
  DocumentToolBar,
  DocumentWrapper,
  EditEditor,
  ErrorFourOhFour,
  GlobalTemplates,
  IFrameSignature,
  KanbanHeader,
  KanbanWrapper,
  ListDocTemplates,
  NavBarWrapper,
  Notes,
  NotifyBanner,
  OrgTemplates,
  PipelineWrapper,
  PriceListCard,
  PricebookGrid,
  PricebookList,
  ProductGrid,
  QuotationTopBarV2,
  QuotationTopbar,
  QuotationUpload,
  Table,
  TemplateLeftSection,
  TitleBar,
  ToolPaneWrapper,
  WorkFlowList,
  BillingBandInfo,
};



// WEBPACK FOOTER //
// ./src/components/index.js